import React from 'react';
import styles from '@/styles/components/DashboardHeader.module.css';
import { LogOut } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import { toBackendUrl } from '@/lib/utils';

const DashboardHeader = ({ title }) => {
  const { user, company, logout } = useAuth();
  const defaultLogo = '/icons/Logo_New.png';
  const companyLogo = company?.logoUrl ? toBackendUrl(company.logoUrl) : null;
  const role = user?.role;
  const roleStyles = role === 'AGENCY' ? 'bg-blue-100 text-blue-800' : role === 'MERCHANT' ? 'bg-green-100 text-green-800' : role === 'REDEEMER' ? 'bg-yellow-100 text-yellow-800' : 'bg-muted text-foreground';
  const roleName = role === 'AGENCY' ? 'Agentur' : role === 'MERCHANT' ? 'Händler' : role === 'REDEEMER' ? 'Entwerter' : 'Benutzer';
  return (
    <header className={styles.root}>
      <div className={styles.inner}>
        <div className={styles.row}>
          <div className={styles.left}>
            <img src={companyLogo || defaultLogo} alt="Logo" className="h-10 w-10 rounded-full object-cover" />
            <span className={`px-3 py-1 text-sm font-medium rounded-full ${roleStyles}`}>{roleName}</span>
            {title && <h1 className="text-lg font-semibold text-foreground">{title}</h1>}
          </div>
          <div className={styles.right}>
            <span className={`${styles.email} hidden sm:block`}>{user?.email}</span>
            <button onClick={logout} className="flex items-center text-sm border px-3 py-1 rounded hover:bg-muted">
              <LogOut className="h-4 w-4 mr-1" /> Abmelden
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default DashboardHeader;
